export default __webpack_public_path__ + "static/media/404.28302b95.svg";